import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

import colors from 'airship/design-system/theme/foundations/colors'

import border from '../foundations/borders'
import size from '../foundations/sizes'
import spacing from '../foundations/space'

const helpers = createMultiStyleConfigHelpers(['section', 'header'])

const SectionTheme = helpers.defineMultiStyleConfig({
  baseStyle: {
    section: {
      backgroundColor: colors.background.primary,
      borderColor: colors.border.primary,
      borderWidth: '1px',
      borderRadius: border.radii.xs,
      minW: size['4xl'],
      maxW: '1280px',
    },
    header: {
      borderColor: colors.border.primary,
      columnGap: spacing['3xs'],
      paddingTop: spacing['3xs'],
      paddingRight: spacing['3xs'],
      paddingBottom: spacing['3xs'],
      paddingLeft: spacing.xs,
    },
  },
})

export default SectionTheme
